import { useEffect, useState } from "react";
import { MethodsEnum } from "../enums/Methods.ts";
import handleService from "../services/apiService.ts";

export const usePagamentoPolling = (paymentId: string | null, ativo: boolean) => {
  const [pagamento, setPagamento] = useState<{ status: string; data?: any } | null>(null);
  const [pago, setPago] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    if (!paymentId || !ativo) return;

    let isMounted = true;
    let attempts = 0;
    const MAX_ATTEMPTS = 60;

    const fetchStatus = async () => {
      try {
        attempts++;
        const result = await handleService({
          method: MethodsEnum.GET,
          endpoint: `/asaas/pagamento/${paymentId}/status`,
        });

        if (!isMounted) return;

        const paymentStatus = result?.data as { paymentId: string; status: string } | undefined;
        console.log("Status do pagamento recebido no polling:", paymentStatus?.status);

        if (paymentStatus?.status === "CONFIRMED" || paymentStatus?.status === "RECEIVED") {
          console.log(">>> Pagamento CONFIRMADO detectado no polling!");
          setPago(true);
          setPagamento({ status: paymentStatus.status, data: paymentStatus });
          setErro(null);
          clearInterval(interval);
          return;
        }

        setPagamento({ status: paymentStatus?.status || "PENDING" });
        setErro(null);

        if (attempts >= MAX_ATTEMPTS) {
          clearInterval(interval);
          setErro("Tempo limite excedido. Verifique o status do pagamento mais tarde.");
        }
      } catch (error) {
        if (isMounted) {
          setErro("Erro ao consultar status");
        }
      }
    };

    fetchStatus();
    const interval = setInterval(fetchStatus, 5000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [paymentId, ativo]);

  return { pagamento, pago, erro };
};
